<template>
  <div class="block">
    <InformationLayout :showHeader="false" :sections="sections" />
  </div>
</template>

<script>
import InformationLayout from "@/shared/ui/information-layout/InformationLayout.vue";
import dateFormat from "@/shared/lib/date-format";

export default {
  name: "DataReference",
  components: { InformationLayout },

  props: {
    selectedItem: Object,
  },

  data() {
    return {
      rules: {
        name: [
          {
            required: true,
            message: this.$t("Укажите название"),
            trigger: "blur",
          },
        ],
        name_kz: [
          {
            required: true,
            message: this.$t("Укажите значение"),
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: this.$t("Укажите код"),
            trigger: "blur",
          },
        ],
      },
    };
  },

  computed: {
    participant_types() {
      return [
        { code: "INDIVIDUAL", name: this.$t("Физ. лицо") },
        { code: "LEGAL", name: this.$t("Юр. лицо") },
      ];
    },

    sections() {
      if (!this.selectedItem) return [];
      return [
        {
          title: this.$t("Данные справочника"),
          items: [
            {
              label: this.$t("Код"),
              values: [{ text: this.selectedItem.code }],
            },
            {
              label: this.$t("Наименование справочника (рус)"),
              values: [{ text: this.selectedItem?.name }],
            },
            {
              label: this.$t("Наименование справочника (қаз)"),
              values: [{ text: this.selectedItem?.name_kz }],
            },
            {
              label: this.$t("Наименование справочника (англ)"),
              values: [{ text: this.selectedItem?.name_en }],
            },
            {
              label: this.$t("Дата создания"),
              values: [{ text: this.dateFormat(this.selectedItem.created_at) }],
            },
          ],
        },
      ];
    },
  },

  methods: {
    validate() {
      return new Promise((resolve) => {
        this.$refs.formInfo.validate((v) => resolve(v));
      });
    },
    dateFormat(date) {
      if (!date) {
        return this.$t("Не указано");
      }
      return dateFormat.timestamp_to_local_tz(date, "DD.MM.YYYY, HH:mm");
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  @apply w-full h-full bg-white rounded-2xl p-8 overflow-auto;
}
</style>
